import React from 'react';
import { AppId, FCX, usePlatformContext } from '@datassential/platform-ui-lib';
import PublicationCard, { PublicationCardTooltip } from '@components/PublicationCard/PublicationCard';
import { iReportProPublication } from '@models/ReportProPublication';
import { READ_ABOUT_IT_TITLE } from './HomeLandscape.constants';

interface LandscapeReadAboutItProps {
    publications: iReportProPublication[];
}

const LandscapeReadAboutIt: FCX<LandscapeReadAboutItProps> = ({ publications }) => {
    const {
        userInfo: { products, reportProDetailsUrl },
    } = usePlatformContext();
    const productRP = products[AppId.ReportPro];
    const detailsPath = process.env.REACT_APP_RP_ITEM_LINK ?? reportProDetailsUrl;

    const visiblePublications = publications.slice(0, 3);

    return (
        <div className="LandscapeReadAboutIt" data-testid="blockLandscapeReadAboutIt">
            <h3 className="LandscapeReadAboutIt__title">{READ_ABOUT_IT_TITLE}</h3>
            <div className="LandscapeReadAboutIt__cards">
                {visiblePublications.map((publication, index) => {
                    const tooltipId = `landscape-publication-${publication.id}`;
                    return (
                        <React.Fragment key={publication.id}>
                            <PublicationCard
                                data={publication}
                                index={index}
                                link={`${productRP.url}${detailsPath}${publication.id}`}
                                tooltipId={tooltipId}
                                testIdBase="LandscapePublication"
                            />
                            <PublicationCardTooltip
                                className="LandscapeReadAboutIt__card-tooltip"
                                data={publication}
                                index={index}
                                tooltipId={tooltipId}
                                testIdBase="LandscapePublication"
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default LandscapeReadAboutIt;
